import React from "react";
import { connect } from "react-redux";
import PT from "prop-types";
import assetify from "@quintype/framework/assetify";

// TODO: Get sister company dynamically based on config
import "./styles.m.css";
import { Button } from "../../basic/button";

import NHlogo from "../../basic/images/nh.svg";
import NJlogo from "../../basic/images/nav.svg";
import QAlogo from "../../basic/images/qaumi.svg";

import get from "lodash/get";

function SisterCompaniesBase({ className = "", publisherAttributes = {} }) {
  return (
    <div className={className}>
      <div
        styleName={`sister-companies ${publisherAttributes.lang === "hi" ? "sister-company-nj" : ""} ${
          publisherAttributes.lang === "ur" ? "sister-company-qa" : ""
        } ${publisherAttributes.lang === "en" ? "sister-company-nh" : ""}`}
      >
        {publisherAttributes.lang !== "hi" ? (
          <a href="https://www.navjivanindia.com/" rel="noopener noreferrer" target="_blank">
            <img className="nj-logo" src={`${assetify(NJlogo)}`} alt="logo" width="90" />
          </a>
        ) : null}
        {publisherAttributes.lang !== "ur" ? (
          <a href="https://www.qaumiawaz.com/" rel="noopener noreferrer" target="_blank">
            <img className="ur-logo" src={`${assetify(QAlogo)}`} alt="logo" width="120" />
          </a>
        ) : null}
        {publisherAttributes.lang !== "en" ? (
          <a href="https://www.nationalheraldindia.com/" rel="noopener noreferrer" target="_blank">
            <img className="nh-logo" src={`${assetify(NHlogo)}`} alt="logo" width="140" />
          </a>
        ) : null}
        {publisherAttributes.lang !== "ur" ? (
          <Button>
            <a
              href={publisherAttributes["epaper_link"] ? publisherAttributes["epaper_link"] : "javascript:void(0)"}
              rel="noopener noreferrer"
              target="_blank"
            >
              E paper
            </a>
          </Button>
        ) : null}
      </div>
    </div>
  );
}

SisterCompaniesBase.propTypes = {
  className: PT.string,
  publisherAttributes: PT.object
};

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const SisterCompanies = connect(
  mapStateToProps,
  null
)(SisterCompaniesBase);
